export default __webpack_public_path__ + "static/media/MaterialScience.2c3ee8eb.png";